var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.257 13.968l-1.544 1.544c-1.387-3.278-.751-7.208 1.92-9.879 3.247-3.246 8.352-3.489 11.883-.74M6.484 19.108c3.533 2.747 8.637 2.506 11.882-.74 2.671-2.672 3.308-6.602 1.921-9.88l-1.544 1.544M9.898 14.1l4.2-4.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.298 13.947a.249.249 0 010 .353.249.249 0 01-.353 0 .249.249 0 010-.354.249.249 0 01.353 0M10.056 9.7a.25.25 0 11-.354.354.25.25 0 11.354-.354",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgVatRate;